import {
  isDesktop
} from './helpers';

const hamburgerWrapper = document.querySelector(".hamburger__wrapper");
const hamburger = document.querySelector(".hamburger");
const body = document.querySelector('body');
const navigation = document.querySelector('.navigation');
const header = document.querySelector('.header');

/**
 * Sticky header on scroll (front-page only)
 */
if (header) {
  const scrollThreshold = 50;
  const nav = header.querySelector('.header__navigation');

  /**
   * Zodra de navigatie op position: fixed gaat, valt ze uit de pagina en krimpt
   * die met precies de hoogte van de navigatie. Daardoor schoot de pagina bij
   * vijftig pixels scroll ineens honderd pixels door.
   *
   * Dat compenseren met een marge werkt niet betrouwbaar: een marge klapt samen
   * met die van het blok eronder, en dan komt er maar een deel terug. Op de ene
   * pagina klopte het, op de andere scheelde het tachtig pixels. Daarom zetten
   * we een echt blokje neer op de plek waar de navigatie stond, met exact haar
   * hoogte. Dat kan niet samenklappen en niet dubbel tellen.
   */
  const spacer = document.createElement('div');
  spacer.className = 'header__navigation-spacer';
  spacer.setAttribute('aria-hidden', 'true');

  const syncSpacer = () => {
    if (!nav) return;

    if (header.classList.contains('header--scrolled')) {
      spacer.style.height = Math.round(nav.getBoundingClientRect().height) + 'px';
      if (!spacer.parentNode) nav.insertAdjacentElement('afterend', spacer);
    } else if (spacer.parentNode) {
      spacer.remove();
    }
  };

  const handleScroll = () => {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
    syncSpacer();
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', syncSpacer);

  // Initial check
  handleScroll();
}

/**
 * Toggle menu on menu-icon click
 */
if (hamburgerWrapper) {

  hamburgerWrapper.addEventListener("click", function () {
    if (!body.classList.contains('sub-menu-active')) {
      toggleMenu();
    }
  });
}
  
/**
 * Toggle menu on mobile if click on link with Anchor
 */
const navigationItems = document.querySelectorAll('.menu-item a');
if (navigationItems) {
  navigationItems.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      if (e.target.hash) {
        toggleMenu();
      } else {
        return true;
      }
    })
  });
}

/**
 * Toggle mobile menu function
 */
function toggleMenu() {
  if (!isDesktop()) {
    hamburger.classList.toggle("is-active");
    body.classList.toggle('modal-open');

    if (body.style.overflow === 'hidden') {
      body.style.overflow = 'initial';
    } else {
      body.style.overflow = 'hidden';
    }
    body.classList.toggle('navigation-is-open');
    navigation.classList.toggle('navigation__is-open');
    closeAllSubMenus();
  }
}



/**
 * 
 * #########################
 * Mobile section
 * #########################
 * 
 */
const listItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
const arrayListItemsWithChildren = [...listItemsWithChildren];
const mainMenu = document.querySelector('.nav__menu');
const navWrapper = document.querySelector('.navwrapper');
const backButton = document.querySelector('.back-button');
const hamburgerBackButton = document.querySelector('.hamburger__backbutton');

/**
 * Opening sub menu
 */
if (!isDesktop()) {
  if (arrayListItemsWithChildren) {
  arrayListItemsWithChildren.forEach(listItem => {
    let subMenu = listItem.querySelector('.sub-menu');
    let navAnchor = listItem.querySelector('.nav__anchor');

    listItem.addEventListener('click', (e) => {

      if (e.target.parentNode.parentNode.classList.contains('sub-menu')) {
        return true;
      } else {

        e.preventDefault();

        listItem.classList.add('sub-menu-active');
        subMenu.classList.add('active');

        let inlineItem = document.createElement('li');
        inlineItem.innerHTML = listItem.innerHTML;
        inlineItem.setAttribute('id', 'subMenuTitle');

        inlineItem.removeChild(inlineItem.querySelector('.sub-menu'));

        if (!subMenu.querySelector('#subMenuTitle')) {
          subMenu.prepend(inlineItem);
        }

        mainMenu.classList.add('nav__menu__sub-menu-active');
        navWrapper.classList.add('bg-white');
        body.classList.add('sub-menu-active');
        hamburgerBackButton.classList.add('active');

      }
    })

  })
}

}

if (backButton) {

  backButton.addEventListener('click', (e) => {
    e.preventDefault();
    closeAllSubMenus();
    hamburgerBackButton.classList.remove('active');
  });
  
}

/**
 * Closing submenu
 */
function closeAllSubMenus() {
  arrayListItemsWithChildren.forEach(listItem => {
    let subMenu = listItem.querySelector('.sub-menu');
    let navAnchor = listItem.querySelector('.nav__anchor');

    listItem.classList.remove('sub-menu-active');
    subMenu.classList.remove('active');
    mainMenu.classList.remove('nav__menu__sub-menu-active');
    navWrapper.classList.remove('bg-white');
    body.classList.remove('sub-menu-active');
  });
}